import * as React from "react";

function buttonVariants({
  variant = "default",
  size = "default",
  className = "",
} = {}) {
  const base =
    "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";

  const variants = {
    default: "bg-primary text-primary-foreground hover:bg-primary/90",
    destructive:
      "bg-destructive text-destructive-foreground hover:bg-destructive/90",
    outline:
      "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
    secondary:
      "!bg-secondary !text-secondary-foreground !hover:bg-secondary/80",
    ghost: "!hover:bg-accent !hover:text-accent-foreground",
    link: "text-primary underline-offset-4 hover:underline",
  };

  const sizes = {
    default: "!h-10 !px-4 !py-2",
    sm: "!h-9 !rounded-md !px-3",
    lg: "!h-11 !rounded-md !px-8",
    icon: "!h-10 !w-10",
  };

  return [base, variants[variant], sizes[size], className]
    .filter(Boolean)
    .join(" ");
}

const Button = React.forwardRef((props, ref) => {
  const {
    className,
    variant,
    size,
    asChild = false,
    children,
    ...rest
  } = props;

  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children, {
      ...rest,
      ref,
      className: buttonVariants({ variant, size, className }),
    });
  }

  return (
    <button
      className={buttonVariants({ variant, size, className })}
      ref={ref}
      {...rest}
    >
      {children}
    </button>
  );
});

Button.displayName = "Button";

export { Button, buttonVariants };
